import { MembershipsCreatorV2ApiClient } from '@fourthwall/services/dist/MembershipsCreatorV2ApiClient'
import { createMutationHook } from '@fourthwall/utils/dist/queries'

export const useCreateMultipleImagePostMutation = createMutationHook(
  MembershipsCreatorV2ApiClient.createImagePost,
  {
    mutationKey: ['createMultipleImagePost'],
  },
)
